import { render, staticRenderFns } from "./NewOvi.html?vue&type=template&id=c54c7550&scoped=true&external"
import script from "./NewOvi.vue?vue&type=script&lang=js"
export * from "./NewOvi.vue?vue&type=script&lang=js"
import style0 from "./NewOvi.scss?vue&type=style&index=0&id=c54c7550&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54c7550",
  null
  
)

export default component.exports